<i18n>
{
  "en": {
    "text": "Click <strong>here</strong> to select your csv file"
  }
}
</i18n>

<script>
import { csvAcceptedFormats } from '@/config/constants';

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
    },
  },

  data() {
    return {
      isOver: false,
      csvAcceptedFormats,
      uuid: Math.random().toFixed(16),
    };
  },

  methods: {
    onDrop(event) {
      const items = event.dataTransfer.items;
      let files = event.dataTransfer.files || [];

      if (items) {
        files = Array.from(items)
          .filter((item) => item.kind === 'file')
          .map((item) => item.getAsFile());
      }

      this.$emit('change', this.multiple ? files : files[0]);
      this.$refs.file.value = '';
    },
    onChange(files) {
      files = files || [];
      this.$emit('change', this.multiple ? files : files[0]);
      this.$refs.file.value = '';
    },
  },
};
</script>

<template>
  <label
    class="dropzone w-360 mxw-full mx-auto color-main"
    :class="isOver ? 'bgc-main_light': ''"
    :for="uuid"
    @drop.prevent="onDrop"
    @mouseover.prevent="isOver = true"
    @mouseout.prevent="isOver = false"
    @dragover.prevent="isOver = true"
    @dragleave.prevent="isOver = false"
  >
    <input
      ref="file"
      class="sr-only"
      type="file"
      :id="uuid"
      :accept="csvAcceptedFormats"
      @change="onChange($event.target.files)">
    <ion-icon class="fsize-16" :src="require('@/assets/img/upload.svg')" />
    <br>
    <span v-show="!text">
      <span v-once v-html="$t('text')" />
    </span>
    <span>{{ text }}</span>
  </label>
</template>

<style lang="scss" scoped>
.dropzone {
  display: block;
  padding: 20px;
  text-align: center;
  border: 2px dashed map.get($colors, 'main');
  border-radius: $radius;
  cursor: pointer;
}
</style>
